import { Box, Breadcrumbs, Container, Divider, Link, Typography } from "@mui/material"
import PartnerSlider from "../components/PartnerSlider"
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux"
import { RootState } from "../../../redux/store"
import PageLang from "../../../config/page.languge"

const HyperlinkPolicy = () => {
    const language = useSelector((state: RootState) => state.language.language);
    return (
        <>
            <Box sx={{ backgroundImage: "url('images/heading.png')", backgroundSize: "cover", backgroundPosition: "center", height: '150px', display: 'flex', alignItems: 'center' }}>
                <Container sx={{ pb: 3, mt: { xs: 13, sm: 3 } }}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link
                            component={RouterLink}
                            to="/"
                            underline="hover"
                            color="inherit"
                            sx={{ textDecoration: 'none' }}
                        >
                            <Typography variant="h4" sx={{ color: 'text.light' }} >{PageLang?.homeTitle[language]}</Typography>
                        </Link>
                        <Typography variant="h4" sx={{ color: 'text.secondary' }}>{PageLang?.hyperlinkTitle[language]}</Typography>
                    </Breadcrumbs>
                </Container>
            </Box>
            <Container sx={{ pb: 3, mt: 3 }}>
                <Box sx={{}}>
                    <Typography variant="h5" fontWeight="bold" mb={1} sx={{ fontSize: { xs: "1rem", md: "1.5rem" }, }}> {PageLang?.hyperlinkTitleSubTitleOne[language]} </Typography>
                    <Divider sx={{ width: "5%", borderBottomWidth: 2, bgcolor: "background.footer", mb: 2 }} />
                    <Typography variant="h6" sx={{ color: '#000', textAlign: 'justify' }}>
                        {PageLang?.hyperlinkTitleSubTextOne[language]}
                    </Typography>
                    <Typography variant="h5" fontWeight="bold" mb={1} sx={{ fontSize: { xs: "1rem", md: "1.5rem" }, mt: 3 }}>{PageLang?.hyperlinkTitleSubTitleTwo[language]} </Typography>
                    <Divider sx={{ width: "5%", borderBottomWidth: 2, bgcolor: "background.footer", mb: 2 }} />
                    <Typography variant="h6" sx={{ color: '#000', textAlign: 'justify' }}>{PageLang?.hyperlinkTitleSubTextTwo[language]}
                    </Typography>
                </Box>
                <Box sx={{ width: "100%", py: 2, backgroundColor: "background.paper" }}>
                    <PartnerSlider />
                </Box>
            </Container>
        </>
    )
}
export default HyperlinkPolicy